import React, { useState, useEffect, useRef, useMemo } from "react";
import PropTypes from "prop-types";
import { Row, Col } from "react-bootstrap";
import { orderBy } from "lodash";

const TasksServiceCallContainer = ({
  serviceId,
  services,
  disabled,
  values,
  onChange,
  auth,
  reviewType,
  taxCode,
  index,
  tasksLength
}) => {
  const [tasks, setTasks] = useState([]);
  const ref = useRef();

  const displayTaxCode = useMemo(
    () =>
      (tasksLength % 2 === 1 && (tasksLength - 1) / 2 === index) ||
      (tasksLength % 2 === 0 && tasksLength / 2 === index + 1),
    [tasksLength, index]
  );

  useEffect(() => {
    if (serviceId && Array.isArray(services)) {
      const service = services.find((_service) => _service._id === serviceId);
      setTasks(
        service && Array.isArray(service.tasks)
          ? orderBy(service.tasks, "task.description").map((_task) => ({
              value: _task._id,
              label: _task.task.description
            }))
          : []
      );
    }
  }, [serviceId, services]);

  return (
    <div className="tasks-service-container">
      <Row style={{ display: "flex", position: "relative" }}>
        <Col xs={8}>
          <select
            className={`table-select ${auth.isNightMode ? "dark-select" : ""}`}
            defaultValue={values.service_task}
            disabled={disabled}
            name="service_task"
            style={{ border: "none", width: "100%" }}
            onChange={({ target: { value } }) =>
              onChange("service_task", value, serviceId)
            }
          >
            {tasks.map((task) => (
              <option
                key={task.value}
                value={task.value}
                selected={values.service_task === task.value}
              >
                {task.label}
              </option>
            ))}
          </select>
        </Col>
        <Col xs={1} className="duration-units">
          <select
            className={`table-select ${auth.isNightMode ? "dark-select" : ""}`}
            defaultValue={values.duration_units}
            disabled={disabled}
            style={{ border: "none", width: "100%" }}
            onChange={({ target: { value } }) =>
              onChange("duration_units", value, serviceId)
            }
          >
            {[
              { value: "Hours", label: "Hours" },
              { value: "Minutes", label: "Minutes" }
            ].map((task) => (
              <option
                key={task.value}
                selected={values.duration_units === task.value}
                value={task.value}
              >
                {task.label}
              </option>
            ))}
          </select>
        </Col>
        <Col xs={1}>
          <input
            className={`review-input ${auth.isNightMode ? "dark-input" : ""}`}
            disabled={disabled}
            name="actual_duration"
            ref={ref}
            style={{ border: "none" }}
            type="number"
            defaultValue={values.actual_duration}
            onBlur={(e) => {
              const durationInMinutes = values.duration_units === "Minutes";
              const roundValue = durationInMinutes ? 5 : 2;
              const value = parseFloat(e.target.value, 10);
              const result = parseFloat(value / roundValue, 10) * roundValue;
              const finalValue = durationInMinutes
                ? Math.round((result + Number.EPSILON) * 100) / 100
                : result;
              ref.current.value = finalValue;
              onChange("actual_duration", finalValue);
            }}
          />
        </Col>
        <Col
          xs={1}
          style={{
            alignSelf: "center",
            display: displayTaxCode ? "block" : "none",
            position: "relative"
          }}
        >
          <div
            style={{
              position: tasksLength % 2 === 0 ? "absolute" : "unset",
              top: (tasksLength - 1) * 10
            }}
          >
            {reviewType === "Invoice" && taxCode ? `Tax: ${taxCode}` : null}
          </div>
        </Col>
      </Row>
    </div>
  );
};

TasksServiceCallContainer.propTypes = {
  serviceId: PropTypes.string,
  services: PropTypes.array,
  disabled: PropTypes.bool,
  values: PropTypes.object,
  onChange: PropTypes.func,
  auth: PropTypes.object,
  reviewType: PropTypes.string,
  taxCode: PropTypes.string,
  index: PropTypes.number,
  tasksLength: PropTypes.number
};

export default TasksServiceCallContainer;
